/** Why a historical session ended (numeric wire values from backend). */
export default Object.freeze({
  ReplacedByAnotherInstallation: 1,
  InstallationReassigned: 2,
  ManuallyRevoked: 3,
  AgentDisabled: 4,
});
